import React from 'react';
import HomePage from './HomePage.jsx';
import AgentsPage from '../agents/AgentsPage.jsx';
import KnowledgeBasePage from '../knowledge_base/KnowledgeBasePage.jsx';
import ConversationRecords from "../calls/ConversationRecords.jsx"
import CallDetails from "../calls/CallDetails.jsx"
import CustomerRecords from "../customers/CustomerRecords.jsx";
import CustomerDetails from "../customers/CustomerDetails.jsx";
import CampaignsPage from '../campaigns/CampaignsPage.jsx';
import CampaignDetails from '../campaigns/CampaignDetails.jsx';
import PhoneNumberRecords from '../phone-numbers/PhoneNumberRecords.jsx';
import AgentDetails from '../agents/AgentDetails.jsx';
import WidgetsPage from '../widgets/WidgetsPage.jsx';

const VoiceAgentsDashboard = ({ 
  selectedMenu, 
  selectedClientId, 
  selectedOptions,
  openContact,
  setOpenContact 
}) => {

  const renderComponent = () => {
    switch (selectedMenu) {
      case 'VA Widgets':
        return <WidgetsPage clientID={selectedClientId} serviceID={selectedOptions} />;
      case 'VA Home':
        return (
          <HomePage 
            clientID={selectedClientId}
            selectedOptions={selectedOptions}
          />
        );
      
      case 'VA Agents':
        return (
          <AgentsPage 
            clientID={selectedClientId}
            selectedOptions={selectedOptions}
          />
        );
      
      case 'VA Conversations':
        return (
          <ConversationRecords 
            clientID={selectedClientId}
            serviceID={selectedOptions}
          />
        );
      case 'VA Customers':
        return (
          <CustomerRecords 
            clientID={selectedClientId}
            serviceID={selectedOptions}
          />
        );
      case 'VA Campaigns':
          return (
            <CampaignsPage 
              clientID={selectedClientId}
              selectedOptions={selectedOptions}
              serviceID={selectedOptions}
            />
          );
      
      case 'VA Knowledge Base':
        return (
          <KnowledgeBasePage 
            clientID={selectedClientId}
          />
        );
      
      case 'VA Call ID':
        return (
          <CallDetails 
            selectedOption={selectedOptions}
            selectedClientId={selectedClientId}
            selectedSegment={selectedOptions}
          />
        );
      
      case 'VA Customer ID':
        return (
          <CustomerDetails 
            selectedClientId={selectedClientId}
            selectedOption={selectedOptions}
          />
        );
      case 'VA Campaign ID':
        return (
          <CampaignDetails 
            selectedClientId={selectedClientId}
            selectedOption={selectedOptions}
          />
        );
      case 'VA Agent ID':
        return (
          <AgentDetails 
            clientID={selectedClientId}
            serviceID={selectedOptions}
          />
        );
      case 'VA Phone Number':
        return (
          <PhoneNumberRecords 
            clientID={selectedClientId}
            serviceID={selectedOptions}
          />
        );
      
      default:
        return (
          <HomePage 
            clientID={selectedClientId}
            selectedOptions={selectedOptions}
          />
        );
    }
  };

  return (
    <div className="voice-agents-dashboard h-full">
      {renderComponent()}
    </div>
  );
};

export default VoiceAgentsDashboard;
